import AICampusFooter from '@/components/probaworkflows_base_components/AICampusFooter/AiFooter.vue';
import NavigationBackButton from '@/components/probaworkflows_base_components/NavigationBackButton/NavigationBackButton.vue';
import {
  get_headers,
  VIEW_REQUESTS_INFO_URL
} from '@/utils/constants/constants';
import alert_mixin from '@/utils/mixins/alert_mixin';
import axios from 'axios';

export default {
  name: 'RequestedInformation',
  mixins: [alert_mixin],
  components: {
    AICampusFooter,
    NavigationBackButton
  },
  data: () => ({
    active_tab: "Unresolved",
    tabs: [
      "Unresolved",
      "Resolved",
    ],
    unresolved_requests: [],
    resolved_requests: [],
    application_id: '',
    headers: '',

  }),
  mounted() {
    this.headers = get_headers();
    const raw_app_id = sessionStorage.getItem('application_id');
    this.application_id = raw_app_id && !isNaN(Number(raw_app_id)) ? Number(raw_app_id) : null;
    this.get_requests();
  },
  methods: {
    set_active_tab(tab) {
      this.active_tab = tab;
    },

    get_requests() {

      const query_params = {
        application_id: this.application_id,
      };

      if (!query_params.application_id) return;


      axios.get(VIEW_REQUESTS_INFO_URL, {
        headers: this.headers,
        params: query_params
      })
        .then(response => {

          const response_data = response.data;

          if (response_data.status === 'success') {

            const mapped_request_data = response_data.data.map(request => ({
              "id": request.id,
              "sender": request.requested_by_first_name + " " + request.requested_by_last_name,
              "message": request.message,
              "is_resolved": request.is_resolved,
              "is_sent": request.is_sent,
              "is_read": request.is_read,
              "date": request.date_created,
            }),
            );

            this.unresolved_requests = mapped_request_data.filter(request => request.is_resolved === false);
            this.resolved_requests = mapped_request_data.filter(request => request.is_resolved === true);


          } else {
            this.show_error('Error fetching requests');
          }
        })
        .catch(error => {
          if (error.response && error.response.data) {
            this.show_error(error.response.data.message);
          }
        });
    },

    selected_unresolved_request(unresolved_request_id) {
      this.$router.push({
        path: '/unresolved_request',
        query: {
          request_id: unresolved_request_id,
        }
      });
    },

    selected_resolved_request(resolved_request_id) {
      this.$router.push({
        path: '/resolved_requests',
        query: {
          request_id: resolved_request_id,
        }
      });
    }
  }
}